export default "__VITE_ASSET__BuCqynwY__"